import { complianceApi } from './complianceApiBase';
import { ComplianceItemView, ComplianceListItemView, ComplianceListFilters, ComplianceDocumentView } from './types/complianceTypes';

export const complianceQueriesApi = complianceApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get a single compliance requirement by ID
    getComplianceItemById: builder.query<ComplianceItemView, string>({
      query: (id) => ({
        url: 'Compliance',
        params: { id },
      }),
      providesTags: (result, error, id) => [{ type: 'Compliance', id }],
    }),

    // Get the dashboard grid list, optionally filtered
    getComplianceItems: builder.query<ComplianceListItemView[], ComplianceListFilters | void>({
      query: (filters) => ({
        url: 'Compliances',
        params: filters || undefined,
      }),
      providesTags: ['ComplianceList'],
    }),

    // List documents for a compliance requirement (calls #99's existing, unmodified endpoint)
    listComplianceDocuments: builder.query<ComplianceDocumentView[], string>({
      query: (complianceItemId) => ({
        url: `compliance/${complianceItemId}/documents`,
        method: 'GET',
      }),
      providesTags: (result, error, complianceItemId) => [
        { type: 'ComplianceDocument', id: complianceItemId },
        'ComplianceDocument',
      ],
    }),
  }),
});

export const {
  useGetComplianceItemByIdQuery,
  useGetComplianceItemsQuery,
  useListComplianceDocumentsQuery,
} = complianceQueriesApi;
